import { FC } from 'react';
import { Routes, Route } from 'react-router';

import Login from 'Pages/Auth/Login';
import Signup from 'Pages/Auth/Signup';
import SignupGoogle from 'Pages/Auth/SignupGoogle';
import ForgotPassword from 'Pages/Auth/ForgotPassword';
import ResetPassword from 'Pages/Auth/ResetPassword';
import ExternalAuth from 'Pages/Auth/ExternalAuth';

const UnauthenticatedRoutes: FC = () => {
  return (
    <Routes>
      <Route path='/'>
        <Route index element={<Login />} />
        <Route path='*' element={<Login />} />
        <Route path='login/:emailHash?' element={<Login />} />
        <Route path='externalauth' element={<ExternalAuth />} />
        <Route path='signupgoogle' element={<SignupGoogle />} />
        <Route path='signup/:emailHash?' element={<Signup />} />
        <Route path='forgotpassword' element={<ForgotPassword />} />
        <Route path='resetpassword' element={<ResetPassword />} />
      </Route>
    </Routes>
  );
};

export default UnauthenticatedRoutes;
